import { Button, Card, CardContent, CardHeader, Checkbox, Input, Label } from "@repo/ui";
import { useEffect, useState } from "react";

type Todo = { id: number; title: string; completed: boolean; createdAt: string };

export function Home() {
  const [todos, setTodos] = useState<Todo[]>([]);
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);

  async function fetchTodos() {
    const res = await fetch("/api/todos");
    const data: Todo[] = await res.json();
    setTodos(data);
  }

  useEffect(() => {
    fetchTodos();
  }, []);

  async function addTodo(e: React.FormEvent) {
    e.preventDefault();
    const t = title.trim();
    if (!t) return;
    setLoading(true);
    await fetch("/api/todos", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ title: t }),
    });
    setTitle("");
    await fetchTodos();
    setLoading(false);
  }

  async function toggleTodo(todo: Todo) {
    await fetch(`/api/todos/${todo.id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ completed: !todo.completed }),
    });
    fetchTodos();
  }

  async function deleteTodo(id: number) {
    await fetch(`/api/todos/${id}`, { method: "DELETE" });
    fetchTodos();
  }

  return (
    <div className="min-h-dvh flex items-start justify-center p-6">
      <Card className="w-full max-w-xl border-none bg-card/60 backdrop-blur supports-[backdrop-filter]:bg-card/50">
        <CardHeader>
          <h1 className="text-3xl font-semibold tracking-tight">Todos</h1>
          <p className="text-sm text-muted-foreground">Ultra-simple list to test DB CRUD</p>
        </CardHeader>
        <CardContent className="space-y-6">
          <form onSubmit={addTodo} className="flex items-center gap-3">
            <div className="grid w-full gap-1.5">
              <Label htmlFor="title" className="sr-only">
                New todo
              </Label>
              <Input
                id="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Add a task..."
                className="h-11"
              />
            </div>
            <Button type="submit" disabled={loading || !title.trim()} className="h-11 px-5">
              Add
            </Button>
          </form>

          <ul className="space-y-2">
            {todos.map((todo) => (
              <li
                key={todo.id}
                className="flex items-center gap-3 rounded-lg border bg-background/60 px-3 py-2"
              >
                <Checkbox checked={todo.completed} onCheckedChange={() => toggleTodo(todo)} />
                <span className={todo.completed ? "line-through text-muted-foreground" : ""}>
                  {todo.title}
                </span>
                <div className="ml-auto flex items-center gap-2">
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => deleteTodo(todo.id)}
                    className="text-destructive hover:text-destructive"
                  >
                    Delete
                  </Button>
                </div>
              </li>
            ))}
            {todos.length === 0 && <li className="text-sm text-muted-foreground">No todos yet.</li>}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
